jQuery(document).ready(function ($) {

    //----------------------------------------------
    //* GLOBAL
    //---------------------------------------------

    var LazyLoading = (function () {
        function lazyLoadImages() {
            var lazyImages = jQuery('img[data-src], [data-background]');
            lazyImages.each(function () {
                var $this = jQuery(this),
                    src,
                    dataSrc;
                if (!$this.data('src-set')) {
                    if (dataSrc = $this.data('background')) {
                        var delay = 0;
                        if ($this.data('background-delay')) {
                            delay = $this.data('background-delay');
                        }
                        setTimeout(function () {
                            $this.css('background-image', 'url(' + dataSrc + ')');
                            $this.attr('data-background', null);
                        }, delay);
                    } else if (dataSrc = $this.data('src')) {
                        $this.attr('src', $this.data('src'));
                        $this.attr('data-src', null);
                    }
                }
            });
        }

        //check what image from the array is best and change the image src to it
        function changeBgImgSrc(container, srcset) {
            var wWidth = $(window).width();

            if (window.devicePixelRatio >= 2) {
                //            wWidth = wWidth * 2;
            }
            $.each(srcset, function (index, i) {
                //if the next one does exist use the biggest one
                if (srcset[index + 1] == undefined) {
                    container.css({
                        'background-image': 'url(' + srcset[srcset.length - 1].url + ')'
                    });
                } else {
                    //if the current items width is smaller than the screen size and the width of the next item is bigger than the screen size use the current item.
                    if (i.width > wWidth) {
                        container.css({
                            'background-image': 'url(' + i.url + ')'
                        });
                        return false;
                    }
                }
            });
        }

        //grab the image srcet place in array and send it to changeBfImgSrc to check what image is best
        function resBGImages($resimgs) {
            $resimgs.each(function () {
                var container = $(this)
                var sources = $(this).data('src-set');
                var groups = sources.split(',');
                var srcset = [];

                $.each(groups, function (index, i) {
                    var current = this.trim().split(' ');
                    srcset.push({
                        width: parseInt(current[1].replace('w', ''), 10),
                        url: current[0]
                    });
                });

                function compareWidth(a, b) {

                    if (a.width < b.width) {
                        return -1;
                    } else if (a.width > b.width) {
                        return 1;
                    } else {
                        return 0;
                    }
                }
                srcset.sort(compareWidth);
                changeBgImgSrc(container, srcset)
            });
        };

        //run this function when the screen is done resizing
        var resizeId;
        $(window).resize(function () {
            clearTimeout(resizeId);
            resizeId = setTimeout(doneResizing, 500);
        });

        var screenW = $(window).width();

        function doneResizing() {
            var newScreenW = $(window).width();
            //only run if the screen size is larger than it was before
            if (screenW <= newScreenW) {
                var $resimgs = $(':not(.static)[data-src-set]');
                resBGImages($resimgs);
                screenW = newScreenW;
            }
        }

        lazyLoadImages();

        $(window).trigger('resize');
        $(window).trigger('scroll');
    }());

    var MainNavMenu = (function () {

        $('nav.main .menu-item-has-children > a').click(function (e) {
            if ($(window).width() < 960) {
                e.preventDefault();
                $(this).siblings('ul').slideToggle();
            }
        });

        $('.mobile-arrow').click(function (e) {
            //Clicking current dropdown
            if ($(this).closest('li').hasClass('dropdown-active')) {
                $(this).closest('li').removeClass('dropdown-active').find('ul').slideUp();
            } else {
                //Find other open drodowns and close
                $(this).closest('.mobile-main').find('.dropdown-active').removeClass('dropdown-active').find('ul').slideUp();
                //Open current dropdown
                $(this).closest('li').addClass('dropdown-active').find('ul').slideDown();
            }

        });

        $('header > .ham-btn').click(function () {
            if ($(this).hasClass('active')) {
                $(this).toggleClass('active');
                $('header').toggleClass('active');
                $('header .mobile-wrap').fadeOut();
                $('body').toggleClass('no-scroll');
            } else {
                $(this).toggleClass('active');
                $('header').toggleClass('active');
                $('header .mobile-wrap').css('display', 'flex').hide().fadeIn();
                $('body').toggleClass('no-scroll');
            }
        });

    }());

    var smoothScroll = (function () {
        $('a[href^="#"]').on('click', function (e) {
            e.preventDefault();

            var target = this.hash;
            var $target = $(target);

            $('html, body').stop().animate({
                'scrollTop': $target.offset().top
            }, 1200, 'swing', function () {
                window.location.hash = target;
            });
        });
    }());

    //----------------------------------------------
    //* Slick Sliders
    //---------------------------------------------
    var videoSlider = (function () {
        $('.video-slider').each(function () {
            var $section = $(this);
            $section.find('.video-slider_slides').slick({
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                arrows: true,
                appendArrows: $section.find(".slider-arrows"),
                responsive: [

                    {
                        breakpoint: 719,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true
                        }
                    }
                ]

            });

        });
    }());

    var singleSlider = (function () {
        var $imageSlider = $('.slider-gallery');
        if ($imageSlider.length) {
            $imageSlider.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                arrows: true,
                appendArrows: $(".single-slider .slider-arrows"),

            });
        }
    }());

    var otherPrograms = (function () {
        var $programsInspiration = $('.other-programs.slider');
        if ($programsInspiration.length) {
            $programsInspiration.slick({
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                arrows: true,
                appendArrows: $(".programs-bottom .slider-arrows"),
                dots: true,
                appendDots: $(".programs-bottom .slider-dots"),
                responsive: [

                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true
                        }
                    },

                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 1,
                            infinite: true
                        }
                    }
                ]

            });
        }
    }());

    var videoHalf = (function () {
        $('.slider-half').each(function () {
            var $section = $(this);
            var $slider = $section.find('.slider-image-gallery');
            $slider.slick({
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                arrows: true,
                appendArrows: $section.find(".slider-arrows"),
                responsive: [

                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true
                        }
                    },

                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true
                        }
                    }
                ]

            });
        });
    }());

    var SuccessStories = (function () {

        $('.successStoriesFC').each(function () {
            var $section = $(this);
            var $slider = $section.find('.slider');
            var $sliderFor = $section.find('.slider-for');
            var $sliderContent = $section.find('.slider-content');

            $slider.slick({
                mobileFirst: true,
                arrows: true,
                asNavFor: '.successStoriesFC .slider-for, .successStoriesFC .slider-content',
                appendArrows: $section.find(".slider-arrows"),
                prevArrow: '',
            });

            $sliderFor.slick({
                mobileFirst: true,
                centerMode: false,
                slidesToShow: 2,
                arrows: false,
                asNavFor: '.successStoriesFC .slider, .successStoriesFC .slider-content',
            });

            $sliderContent.slick({
                mobileFirst: true,
                slidesToShow: 1,
                arrows: false,
                centerPadding: 0,
                asNavFor: '.successStoriesFC .slider-for, .successStoriesFC .slider',
                fade: true
            });
        });

        $('.successStories .slider').slick({
            mobileFirst: true,
            centerPadding: 0,
            arrows: true,
            appendArrows: $('.successStories .slick-arrows'),
            dots: true,
            appendDots: $('.successStories .slick-dots'),
            responsive: [{
                breakpoint: 539,
                settings: {
                    slidesToShow: 2
                }
            }, {
                breakpoint: 719,
                settings: 'unslick'
            }]
        });
    }());

    var FosterStories = (function () {
        $('.fosterStoriesFC').each(function () {
            var $section = $(this);

            var $slider = $section.find('.slider');
            var $sliderFor = $section.find('.slider-for');
            var $sliderContent = $section.find('.slider-content');

            $slider.slick({
                mobileFirst: true,
                arrows: true,
                asNavFor: '.fosterStoriesFC .slider-for, .fosterStoriesFC .slider-content',
                appendArrows: $section.find(".slider-arrows"),
                prevArrow: '',
            });

            $sliderFor.slick({
                mobileFirst: true,
                centerMode: false,
                slidesToShow: 2,
                arrows: false,
                asNavFor: '.fosterStoriesFC .slider, .fosterStoriesFC .slider-content',
            });

            $sliderContent.slick({
                mobileFirst: true,
                slidesToShow: 1,
                arrows: false,
                centerPadding: 0,
                asNavFor: '.fosterStoriesFC .slider-for, .fosterStoriesFC .slider',
                fade: true
            });
        });

        $('.fosterStories .slider').slick({
            mobileFirst: true,
            centerPadding: 0,
            arrows: true,
            appendArrows: $('.fosterStories .slick-arrows'),
            dots: true,
            appendDots: $('.fosterStories .slick-dots'),
            responsive: [{
                breakpoint: 539,
                settings: {
                    slidesToShow: 2
                }
            }, {
                breakpoint: 719,
                settings: 'unslick'
            }]
        });
    }());

    var Events = (function () {
        var $events = $('.events-slider');
        var sliderData = $events.data('unslick');
        var bpDesktop = 720;

        $events.slick({
            mobileFirst: true,
            slidesToShow: 1,
            centerPadding: '0',
            centerMode: false,
            arrows: false,
            responsive: [{
                breakpoint: bpDesktop,
                settings: 'unslick'
            }]
        });

        $(window).resize(function (x) {
            if (this.innerWidth <= bpDesktop) {
                $events.slick('refresh');
            } else {
                $events.slick('unslick');
            }
        })
    }());

    var relatedArticles = (function () {
        var $articles = $('.related-articles');
        if ($articles.length) {
            $articles.slick({
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                arrows: true,
                appendArrows: $(".articles-container .slider-arrows"),
                prevArrow: '',
                responsive: [

                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true
                        }
                    },

                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            infinite: true
                        }
                    }
                ]

            });
        }
    }());

    var programTestimonials = (function () {
        $('.testimonials').each(function () {
            var $section = $(this);
            var $slider = $section.find('.slider');
            $slider.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                arrows: true,
                appendArrows: $section.find('.slider-arrows'),
                adaptiveHeight: true
            });
        });

    }());

    var Content_w_Slider = (function () {

        if (!$('.contentSlider')) {
            return;
        }

        $('.contentSlider--fw').each(function () {
            var $section = $(this);
            console.log($section.find('.slider'));

            $section.find('.slider').slick({
                mobileFirst: true,
                centerPadding: 0,
                centerMode: true,
                arrows: true,
                infinite: false,
                appendArrows: $section.find(".slider-arrows"),
                dots: true,
                adaptiveHeight: true,
                appendDots: $section.find(".slider-dots"),
                responsive: [{
                        breakpoint: 399,
                        settings: {
                            centerMode: false
                        }
                    },
                    {
                        breakpoint: 539,
                        settings: {
                            slidesToShow: 2,
                            centerMode: false
                        },
                    }, {
                        breakpoint: 799,
                        settings: {
                            slidesToShow: 3,
                            centerMode: false
                        }
                    }, {
                        breakpoint: 959,
                        settings: {
                            slidesToShow: 4,
                            centerMode: false
                        }
                    }

                ]
            });
        });

        $('.contentSlider--halfs').each(function () {
            var $section = $(this);
            console.log($section.find('.slider'));
            $section.find('.slider').slick({
                mobileFirst: true,
                centerPadding: 0,
                centerMode: true,
                infinite: false,
                arrows: true,
                adaptiveHeight: true,
                appendArrows: $section.find('.slider-arrows'),
                dots: true,
                appendDots: $section.find('.slider-dots'),
                responsive: [{
                    breakpoint: 399,
                    settings: {
                        centerMode: false
                    }
                }, {
                    breakpoint: 539,
                    settings: {
                        slidesToShow: 2,
                        initialSlide: 1,
                        centerMode: false
                    }
                }, {
                    breakpoint: 899,
                    settings: {
                        slidesToShow: 1,
                        centerMode: false,
                    }
                }, {
                    breakpoint: 1079,
                    settings: {
                        slidesToShow: 2,
                        initialSlide: 1,
                        centerMode: true,

                    }
                }]
            });
        });

    }());

    $(".slider-arrows .slick-next").click(function () {
        $(this).closest(".slider").find(".slider_slides").slick("slickNext");
    });

    $(".slider-arrows .slick-prev").click(function () {
        $(this).closest(".slider").find(".slider_slides").slick("slickPrev");
    });

    //----------------------------------------------
    //* FLEXIBLE CONTENT
    //---------------------------------------------
    var Instagramfeed = (function () {
        var $IGFeed = $('.instafeed_feed');
        if ($IGFeed.length) {
            var IG = new Instafeed({
                target: document.querySelector('.instafeed_feed'),
                accessToken: $IGFeed.data('tk'),
                get: 'user',
                userId: 249581350,
                sortBy: 'most-recent',
                limit: $IGFeed.data('limit'),
                resolution: 'standard_resolution',
                template: '<a href="{{link}}"><div class="positioner"><img src="{{image}}" /></div></a>'
            }).run();

            $IGFeed.attr('data-id', null).attr('data-tk', null);
        }
    });

    var LogoSlider = (function () {
        $('.logoSlider').each(function () {
            var $section = $(this);
            $section.find('.slider').slick({
                mobileFirst: true,
                centerPadding: 0,
                centerMode: true,
                variableWidth: false,
                arrows: true,
                appendArrows: $section.find('.slider-arrows'),
                autoplay: true,
                slidesToShow: 2,
                responsive: [{
                    breakpoint: 539,
                    settings: {
                        slidesToShow: 4,
                        centerMode: false
                    }
                }]
            });
        });
    }());

    var StackedGallery = (function () {
        $('.stackedGallery').each(function () {
            var $section = $(this);
            $section.find('.slider').slick({
                mobileFirst: true,
                centerPadding: 0,
                slidesToShow: 1,
                appendArrows: $section.find('.slick-arrows'),
                responsive: [{
                    breakpoint: 539,
                    settings: {
                        slidesToShow: 2
                    }
                }, {
                    breakpoint: 959,
                    settings: {
                        rows: 3,
                        slidesPerRow: 2,
                        fade: true
                    }
                }]
            })
        });
    }());

    var VideoEmbed = (function () {
        $('.videoEmbed').each(function () {
            var $section = $(this);
            var $video = $section.find('.vid-wrap');
            var $overlay = $section.find('.videoEmbed_overlay');

            $video.on('mouseenter', function () {
                var $wrap = $(this);

                if ($wrap.data('embed')) {
                    var $iframeCode = $wrap.data('embed');
                    $wrap.append($iframeCode);
                    $wrap.data('embed', '');
                }
            });

            $overlay.click(function () {
                $overlay.remove();
            });

        });
    }());

    //----------------------------------------------
    //* Material Design Gravity Forms
    //---------------------------------------------

    // Text Fields
    $('.form-shortcode .ginput_container_text input[type=text], .form-shortcode .ginput_container_email input[type=text]').focus(function () {

        $(this).addClass('has-value');
        $(this).closest('li').find('label').addClass('has-value');

    }).blur(function () {

        /*On focus out*/
        var input = $(this).val();

        if (input === "") {
            $(this).removeClass('has-value');
            $(this).closest('li').find('label').removeClass('has-value');
        } else {
            $(this).addClass('has-value');
            $(this).closest('li').find('label').addClass('has-value');
        }
    });

    //Credit Card & Address Fields
    $('.form-shortcode .ginput_container_creditcard input[type=text], .form-shortcode .ginput_container_address input[type=text]').focus(function () {

        $(this).addClass('has-value');
        $(this).closest('span').find('label').addClass('has-value');

    }).blur(function () {

        /*On focus out*/
        var input = $(this).val();

        if (input === "") {
            $(this).removeClass('has-value');
            $(this).closest('span').find('label').removeClass('has-value');
        } else {
            $(this).addClass('has-value');
            $(this).closest('span').find('label').addClass('has-value');
        }
    });

    //----------------------------------------------
    //* Single Posts
    //---------------------------------------------
    var imgGallery = (function () {
        $('.img-gallery').each(function () {
            var $section = $(this);
            var $slider = $section.find('.img-gallery_slider .slider');
            var $sliderFor = $section.find('.img-gallery_content .slider-for');
            $slider.slick({
                mobileFirst: true,
                centerPadding: 0,
                centerMode: true,
                arrows: true,
                asNavFor: $sliderFor,
                appendArrows: $section.find('.slider-arrows'),
                prevArrow: '',
                responsive: [{
                    breakpoint: 520,
                    settings: {
                        slidesToShow: 2,
                    }
                }, {
                    breakpoint: 720,
                    settings: {
                        slidesToShow: 1,
                    }
                }]
            });

            $sliderFor.slick({
                mobileFirst: true,
                centerMode: false,
                slidesToShow: 2,
                arrows: false,
                asNavFor: $slider,
            });
        });

    }());

    $('.pdm-lightbox,.pdm-lightbox-email').on('click', 'button.close, .btn--help-close, .modal_close', function (e) {

        $('.pdm-lightbox').fadeOut();
        $('body').removeClass('no-scroll');
        $('.pdm-lightbox .popup').empty();
        $('.pdm-lightbox').attr('class', 'pdm-lightbox');
    });

    $('.pdm-lightbox,.pdm-lightbox-email').on('click', function (e) {
        if (e.target == this) {
            $(this).fadeOut();
            $('body').removeClass('no-scroll');
            $('.pdm-lightbox .popup').empty();
            $('.pdm-lightbox').attr('class', 'pdm-lightbox');
        }
    });

    $('.video-popup').click(function (e) {
        e.preventDefault();
        var content = '';
        content = $(this).data('youtube');
        $('.pdm-lightbox .popup').append(content);
        $('body').addClass('no-scroll');
        $('.pdm-lightbox').addClass('youtube-modal');
        $('.pdm-lightbox').css('display', 'flex').hide().fadeIn();
    });

    $('.modal-trigger').click(function (e) {
        e.preventDefault();
        var $this = $(this),
            content,
            target,
            classes;
        classes = $(this).data('classes');
        target = $this.data('target'),
            content = $(target).html();

        $('.pdm-lightbox .popup').append(content);
        $('body').addClass('no-scroll');
        $('.pdm-lightbox').addClass(classes);

        $('.pdm-lightbox').css('display', 'flex').hide().fadeIn();
    }); /*end modal function*/

    $('.select-section button').click(function () {
        var id = $(this).data('id');
        $('.select-section button.active').removeClass('active');
        $(this).addClass('active');
        $('.campaign-block').addClass('hide');
        $('.campaign-block[data-id="' + id + '"]').removeClass('hide');
    });

    //----------------------------------------------

    //*Accordion

    //---------------------------------------------

    $('.accordion > .accordion_item:eq(0) h4').addClass('active').next().slideDown();

    $('.accordion h4').click(function (e) {
        var dropDown = $(this).closest('.accordion_item').find('.accordion_content');

        $(this).closest('.accordion').find('.accordion_content').not(dropDown).slideUp();

        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
        } else {
            $(this).closest('.accordion').find('h4.active').removeClass('active');
            $(this).addClass('active');
        }

        dropDown.stop(false, true).slideToggle();

        e.preventDefault();
    });

    //----------------------------------------------

    //*Program Modals

    //---------------------------------------------

    $(".modal-link").on("click", function () {
        var modal = $(this).data("modal");
        $(modal).css('display', 'flex').hide().fadeIn();
        $('body').addClass('no-scroll');
    });

    $(".modal").on("click", function (e) {
        var className = e.target.className;
        if (className === "modal" || className === "close") {
            $(this).closest(".modal").fadeOut();
            $('body').removeClass('no-scroll');

            $(".modal iframe").attr("src", $(".modal iframe").attr("src"));
        }
    });

    /*Coronavirus popup*/
    $('#carnival-notification').css('display', 'flex').hide().fadeIn();

    $('.modal_close').on("click", function (e) {
        $(this).closest(".modal").fadeOut();
        $('body').removeClass('no-scroll');
        $(".modal iframe").attr("src", $(".modal iframe").attr("src"));
    });

    //----------------------------------------------

    //*Header

    //---------------------------------------------

    $('.ham--desktop').click(function () {

        if (!$(this).hasClass('ham--active')) {

            //Animation of hamburger menu
            $(this).addClass('ham--active');

            //Slide out of nav
            $(".nav-items").addClass('nav-items--active');

            /*Overflow issue*/
            setTimeout(function () {
                $('.main-menu').addClass('is-open');
            }, 200);

        } else {
            $(this).removeClass('ham--active');
            $(".nav-items").removeClass('nav-items--active');
            $('.main-menu').removeClass('is-open');
            //Search
            $('.search-container').removeClass('search-container--active');
            $('.btn-box--search').removeClass('active');
        }

    });

    $('header .ham--mobile').click(function () {
        if ($(this).hasClass('ham--active')) {
            $(this).toggleClass('ham--active');
            $('header').toggleClass('active');
            $('header nav').slideToggle();
            $('body').toggleClass('no-scroll');
        } else {
            $(this).toggleClass('ham--active');
            $('header').toggleClass('active');
            $('header nav').slideToggle();
            $('body').toggleClass('no-scroll');
        }
    });

    //Search
    $('.btn-box--search').click(function () {

        if (!$('.ham--desktop').hasClass('ham--active')) {
            $('.ham--desktop').addClass('ham--active');
        }

        $(".nav-items").removeClass('nav-items--active');
        $('.main-menu').removeClass('is-open');
        $('#site-search').focus();

        $(this).addClass('active');
        $('.search-container').toggleClass('search-container--active');

    });

    $('.search-form_submit').click(function () {
        console.log('dsfdsf');
        $(this).closest('.search-form').submit();
    });

    $('#site-search').blur(function (e) {
        //Search
        setTimeout(function () {

            $('.search-container').removeClass('search-container--active');
            $('.btn-box--search').removeClass('active');

            if ($(window).scrollTop() === 0) {
                $('.nav-items').addClass('nav-items--active');
                $('.ham').addClass('ham--active');
                $('.main-menu').removeClass('main-menu--scroll').addClass('is-open');
            } else {
                $('.nav-items').removeClass('nav-items--active');
                $('.ham').removeClass('ham--active');
                $('.main-menu').removeClass('is-open');
                $('.main-menu').addClass('main-menu--scroll');
            }
        }, 250);
    });

    $(document).scroll(function () {
        if ($(window).width() > 1300) {
            if ($(window).scrollTop() <= 200) {
                $('.ham').addClass('ham--active');
                $('.main-menu').removeClass('main-menu--scroll').addClass('is-open');
                $('.nav-items').addClass('nav-items--active');
            } else {
                $('.nav-items').removeClass('nav-items--active');
                $('.ham').removeClass('ham--active');
                $('.main-menu').removeClass('is-open');
                $('.main-menu').addClass('main-menu--scroll');
                //Search
                $('.search-container').removeClass('search-container--active');
                $('.btn-box--search').removeClass('active');
            }

        }

    });

    //----------------------------------------------

    //* Pages

    //---------------------------------------------

    var FindAProgram = (function () {

        var $resetFilter = $('#filter-reset');
        $resetFilter.click(function () {
            $('[name="areas-served').val('');
            $('[name="article-type').val('');
            $('[name="search-articles').val('');
        });

        // var $section = $('.programCards');
        // $section.find('.slider').slick({
        //     mobileFirst: true,
        //     centerPadding: 0,
        //     appendArrows: $section.find('.slick-arrows'),
        //     responsive: [{
        //         breakpoint: 639,
        //         settings: {
        //             slidesToShow: 2
        //         }
        //     }, {
        //         breakpoint: 959,
        //         settings: {
        //             slidesToShow: 3
        //         }
        //     }]
        // });
    }());

    var OurLocations = (function () {
        var $map = $('#map');
        var map;
        console.log($map.data('default'));
        if ($map.length) {

            var location_list = [];
            $(".locations-list_item").each(function () {
                var lat = $(this).attr("data-lat");
                var lng = $(this).attr("data-lng");
                if (lat != "" && lng != "") {
                    location_list.push([lng, lat]);
                }
            });
            if (location_list.length > 0) {
                var min1 = 180;
                var min2 = 90;
                var max1 = -180;
                var max2 = -90;
                location_list.forEach(function (item) {
                    min1 = Math.min(item[0], min1);
                    max1 = Math.max(item[0], max1);
                    min2 = Math.min(item[1], min2);
                    max2 = Math.max(item[1], max2);
                });
                lng = (min1 + max1) / 2;
                lat = (min2 + max2) / 2;

                map = new google.maps.Map(document.getElementById('map'), {
                    zoom: 10,
                    center: { lat: Number(lat), lng: Number(lng) }
                });
                location_list.forEach(function (item) {
                    var marker = new google.maps.Marker({
                        position: { lat: Number(item[1]), lng: Number(item[0]) },
                        map: map
                    });
                });
            } else {
                map = new google.maps.Map(document.getElementById('map'), {
                    zoom: 10,
                    center: $map.data('default')
                });
            }
        }
    }());

    //----------------------------------------------

    //* Parts

    //---------------------------------------------
    $('.membersStack .slider').slick({
        mobileFirst: true,
        centerPadding: 0,
        arrows: true,
        appendArrows: $('.membersStack .slick-arrows'),
        dots: true,
        appendDots: $('.membersStack .slick-dots'),
        responsive: [{
            breakpoint: 539,
            settings: {
                slidesToShow: 2
            }
        }, {
            breakpoint: 719,
            settings: 'unslick'
        }]
    });

    function tick() {
        $('.scroll-list li:first').slideUp(700, function () {
            $(this).appendTo($('.scroll-list')).slideDown(700);
        });
    }

    setInterval(function () { tick() }, 2000);

    var BoardDirectory = (function () {
        $boardDir = $('.board-directory');
        if (!$boardDir) { return; }

        var $searchInput = $boardDir.find('#search-input');
        var $searchBtn = $boardDir.find('#search');
        var $members = $boardDir.find('.board-card');

        function filterMembers() {
            console.log(this);
            var input = $('#search-input').val();

            $members.removeClass('hide');
            var $hideThese = $members.filter(function () {
                var filters = this.dataset.filter.toLowerCase();
                if (filters.indexOf(input.toLowerCase()) == -1) {
                    return this;
                }
                console.log(filters);
            });

            $hideThese.addClass('hide');
        }
        $searchInput.on('keyup', function (e) {
            if (e.keyCode == 13) {
                filterMembers();
            }
        });
        $searchBtn.click(filterMembers);

    }());

    AOS.init();

    if (!$.cookie('notification')) {
        setTimeout(function () {
            $(".pdm-lightbox--notification").css("display", "flex");
        }, 2000);
        $.cookie('notification', 'true', { expires: 1 });
    }

});